//FileMaker Widget Mode
// import _ from 'lodash'
import { EventBus } from 'Js/eventBus';
import { actions } from 'Js/actionsProcessor';

export const initialProps = (() => {
  let props = decodeURIComponent(location.hash.substr(1));
  try {
    props = JSON.parse(props);
  }
  catch (e) {}
  // console.log("WIP FM Bridge initialProps");
  // console.log(props);
  return props;
})();

/**
 * @param {string} fileName the name of the file that has the script
 * @param {string} scriptName the name ofthe script to call
 * @param {object|string} data an object or string containing the data to send as the parameter
 */
export const callFMScript = (fileName, scriptName, data, callback) => {
  let parameter = encodeURIComponent(data);
  console.log("calling FM script", scriptName);
  console.log("---->file", fileName);
  console.log("---->parameter!", data);

  if (parameter.length > 1000 && window.clipboardData) {
    window.clipboardData.setData("Text", data);
    parameter = "giant";
  }

  const url =
    "fmp://$/" + fileName + "?script=" + scriptName + "&param=" + parameter;

  //window.location = url;
  const href = window.location.href;
  const body = document.getElementsByTagName("body")[0];
  const a = document.createElement("a");
  a.href = url;
  a.style.display = "none";
  body.appendChild(a);
  a.click();
  a.parentNode.removeChild(a);

  //IE FIX
  if (href.indexOf("#") > -1) {
    setTimeout(function() {
      window.location.href = href;
    }, 1);
  }
};

// to call
// callFMScript(file, script, result);

/**
 * 
 * @params {payload} FM BetterForms payload object
 */
export const handlePayload = (payload) => {




  //CHECK FOR VALID JSON?
  try {
    payload = JSON.parse(payload)
  }
  catch (e) {
    alert('Bad payload JSON passed to BetterForms from FM Client via bfwidget query): ', payload.error.info)
    return false
  }
  console.log({ payload })

  actions.queue(payload.actions); // todo call store instead
  delete payload.actions;
  EventBus.$emit('processWidgetPayload', payload)


  // delete payload.data;
  // this.formSchema = payload // ? result.formSchema : this.formSchema;
  // return payload

  // resolve (result)




};
